import styled from 'styled-components';

export const CardInput = styled.input`
  border: none;
  margin-left: 10px;
`;